// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Menu_V2_Types_CartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_ItemId from "../Restaumatic.Menu.V2.Types.ItemId/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var CrossSellingListItem = function (x) {
    return x;
};
var CrossSellingList = function (x) {
    return x;
};
var CalculatedCrossSellingList = function (x) {
    return x;
};
var newtypeCrossSellingList_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCrossSellingListIt = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCalculatedCrossSel = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldCrossSellingListI = function (dictHasField) {
    return dictHasField;
};
var hasFieldCrossSellingList = function (dictHasField) {
    return dictHasField;
};
var hasFieldCalculatedCrossSe = function (dictHasField) {
    return dictHasField;
};
var eqCrossSellingListItem = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Restaumatic_Menu_V2_Types_CartToOrder.eqCartProductKey)(x.content)(y.content);
        };
    }
};
var eqCrossSellingList = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Map_Ordered.eqOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(eqCrossSellingListItem))(x.items)(y.items) && x.name === y.name;
        };
    }
};
var eqCalculatedCrossSellingL = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Map_Serialized.eqMap(Restaumatic_Menu_V2_Types_ItemId.eqItemId)(Data_Eq.eqArray(Restaumatic_Menu_V2_Types_ItemId.eqItemId)))(x.items)(y.items);
        };
    }
};
var genericCrossSellingListItem = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCrossSellingListItem = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCrossSellingListItem)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "content";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_V2_Types_CartToOrder.showCartProductKey))))({
        reflectSymbol: function () {
            return "CrossSellingListItem";
        }
    }))
};
var unscrambleDecodeCrossSellingListItem = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCrossSellingListItem)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "content";
        }
    })(Restaumatic_Menu_V2_Types_CartToOrder.unscrambleDecodeCartProductKey)(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var genericCrossSellingList = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCrossSellingList = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCrossSellingList)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(/* #__PURE__ */ Data_Map_Ordered.showOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(showCrossSellingListItem)))))({
        reflectSymbol: function () {
            return "CrossSellingList";
        }
    }))
};
var unscrambleDecodeCrossSellingList = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCrossSellingList)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Data_Map_Ordered.udecodeMap(unscrambleDecodeCrossSellingListItem)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var genericCalculatedCrossSellingList = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCalculatedCrossSellingList = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCalculatedCrossSellingList)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "items";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Map_Serialized.showMap(Restaumatic_Menu_V2_Types_ItemId.showItemId)(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_V2_Types_ItemId.showItemId))))))({
        reflectSymbol: function () {
            return "CalculatedCrossSellingList";
        }
    }))
};
var unscrambleDecodeCalculatedCrossSellingList = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCalculatedCrossSellingList)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Data_Map_Serialized.udecodeMap(Restaumatic_Menu_V2_Types_ItemId.ordItemId)(Restaumatic_Menu_V2_Types_ItemId.ufromJSONKeyItemId)(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Menu_V2_Types_ItemId.unscrambleDecodeItemId)))(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var encodeCrossSellingListItem = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCrossSellingListItem)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CrossSellingListItem";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "content";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_CartToOrder.encodeCartProductKey))))))
};
var encodeCrossSellingList = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCrossSellingList)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CrossSellingList";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Map_Ordered.encodeMap(/* #__PURE__ */ Data_Tuple_T2.encodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeCrossSellingListItem))))))))))
};
var encodeCalculatedCrossSellingList = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCalculatedCrossSellingList)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CalculatedCrossSellingList";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Map_Serialized.encodeMap(Restaumatic_Menu_V2_Types_ItemId.asJSONKeyItemId)(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_V2_Types_ItemId.encodeItemId))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_V2_Types_ItemId.encodeItemId))))))))))
};
var decodeCrossSellingListItem = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCrossSellingListItem)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CrossSellingListItem";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "content";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_CartToOrder.decodeCartProductKey))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeCrossSellingList = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCrossSellingList)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CrossSellingList";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Map_Ordered.decodeMap(/* #__PURE__ */ Data_Tuple_T2.decodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeCrossSellingListItem))))(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeCalculatedCrossSellingList = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCalculatedCrossSellingList)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CalculatedCrossSellingList";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Map_Serialized.decodeMap(Restaumatic_Menu_V2_Types_ItemId.ordItemId)(Restaumatic_Menu_V2_Types_ItemId.asJSONKeyItemId)(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_V2_Types_ItemId.decodeItemId))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_V2_Types_ItemId.decodeItemId))))))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    CrossSellingListItem,
    CrossSellingList,
    CalculatedCrossSellingList,
    genericCrossSellingListItem,
    eqCrossSellingListItem,
    showCrossSellingListItem,
    encodeCrossSellingListItem,
    decodeCrossSellingListItem,
    unscrambleDecodeCrossSellingListItem,
    hasFieldCrossSellingListI,
    newtypeCrossSellingListIt,
    genericCrossSellingList,
    eqCrossSellingList,
    showCrossSellingList,
    encodeCrossSellingList,
    decodeCrossSellingList,
    unscrambleDecodeCrossSellingList,
    hasFieldCrossSellingList,
    newtypeCrossSellingList_,
    genericCalculatedCrossSellingList,
    eqCalculatedCrossSellingL,
    showCalculatedCrossSellingList,
    encodeCalculatedCrossSellingList,
    decodeCalculatedCrossSellingList,
    unscrambleDecodeCalculatedCrossSellingList,
    hasFieldCalculatedCrossSe,
    newtypeCalculatedCrossSel
};
//# sourceMappingURL=index.js.map
